import { UseFormRegister, FieldErrors } from "react-hook-form";
import { addFamilyInput } from "../features/families/familySchema";
import FormInput from "./FormInput";

interface Props {
  register: UseFormRegister<addFamilyInput>;
  errors: FieldErrors<addFamilyInput>;
}

const AddFamilyFields = ({ register, errors }: Props) => {
  return (
    <div className="space-y-4">

      <FormInput
        label="שם משפחה"
        register={register("family")}
        error={errors.family?.message}
        placeholder="הכנס שם משפחה"
      />

      <FormInput
        label="שם הורה 1"
        register={register("name_a")}
        error={errors.name_a?.message}
        placeholder="הכנס שם הורה 1"
      />

      <FormInput
        label="שם הורה 2"
        register={register("name_b")}
        error={errors.name_b?.message}
        placeholder="הכנס שם הורה 2"
      />

      <FormInput
        label="אזור מגורים"
        register={register("residence_location")}
        error={errors.residence_location?.message}
        placeholder="הכנס אזור מגורים"
      />

      <FormInput
        label="אימייל"
        type="email"
        register={register("email")}
        error={errors.email?.message}
        placeholder="הכנס אימייל"
      />

      <FormInput
        label="טלפון"
        register={register("phone")}
        error={errors.phone?.message}
        placeholder="הכנס מספר טלפון"
      />

      <FormInput
        label="מספר ילדים"
        register={register("num_of_children")}
        error={errors.num_of_children?.message}
        placeholder="הכנס מספר ילדים"
      />

      <div>
        <label className="block text-sm font-medium text-text-main mb-1">סטטוס</label>
        <select
          {...register("status")}
          className={`w-full bg-white text-text-main rounded-xl px-4 py-3 font-sans text-base shadow-sm border ${
            errors.status ? "border-danger" : "border-border"
          }`}
          defaultValue="ok"
        >
          <option value="" disabled hidden>בחר סטטוס</option>
          <option value="needs_attention">דורש תשומת לב</option>
          <option value="ok">תקין</option>
          <option value="no_meeting_month">לא נפגשו החודש</option>
        </select>
        {errors.status && <p className="text-danger text-sm mt-1">{errors.status.message}</p>}
      </div>
    </div>
  );
};

export default AddFamilyFields;
